import { FoodsIcon, Typography } from "@foodpilot/foods";
import { Box, useTheme } from "@mui/material";

export type PackagingTypeTagKind = "composite" | "element";

type PackagingTypeTagProps = {
    appearance?: "details" | "hub" | "legacy";
    kind: PackagingTypeTagKind;
    label: string;
};

export const PackagingTypeTag = (props: PackagingTypeTagProps) => {
    const { appearance = "hub", kind, label } = props;
    const theme = useTheme();
    const isElement = kind === "element";
    const isDetails = appearance === "details";
    const isLegacy = appearance === "legacy";
    const colors = theme.custom.dataviz.colorsWithExtra[isElement ? 13 : 12];
    const backgroundColor =
        isLegacy ?
            isElement ? theme.custom.blue[100]
            :   theme.custom.coral[100]
        :   colors.variant[100];
    const foregroundColor =
        isLegacy ?
            isElement ? theme.custom.blue[700]
            :   theme.custom.coral[700]
        :   colors.main;
    const iconColor = foregroundColor;

    return (
        <Box
            component="span"
            sx={{
                alignItems: "center",
                backgroundColor,
                borderRadius: theme.spacing(0.5),
                boxSizing: "border-box",
                display: "inline-flex",
                gap: isLegacy ? 0 : theme.spacing(isDetails ? 0.5 : 0.25),
                height: theme.spacing(isDetails ? 3.25 : 3),
                paddingBlock: isLegacy ? 0 : theme.spacing(0.25),
                paddingInlineEnd: isLegacy ? theme.spacing(1) : theme.spacing(isDetails ? 1 : 0.5),
                paddingInlineStart: isLegacy ? theme.spacing(1) : theme.spacing(isDetails ? 0.5 : 0.25),
            }}
        >
            {!isLegacy && (
                <Box component="span" sx={{ color: iconColor, display: "inline-flex", lineHeight: 0 }}>
                    <FoodsIcon icon={isElement ? "box" : "boxes"} size={1} />
                </Box>
            )}
            <Typography
                component="span"
                variant={
                    isLegacy ? "small-bold"
                    : isDetails ?
                        "body-semibold"
                    :   "small-semibold"
                }
                sx={{
                    color: foregroundColor,
                    whiteSpace: "nowrap",
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};
